var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-container",class:_vm.device.isMobile ? 'link-container-mobile' : '',style:({
    fontFamily: _vm.content.textStyle.fontFamily || '',
    fontSize: (_vm.content.textStyle.fontSize + 'rem') || '',
    lineHeight: (_vm.content.textStyle.lineHeight + 'rem') || '',
    textIndent: (typeof _vm.content.textStyle.textIndent === 'string') ? _vm.content.textStyle.textIndent :
      (typeof _vm.content.textStyle.textIndent === 'number') ? (_vm.content.textStyle.textIndent + 'rem') : '',
    fontWeight: _vm.content.textStyle.fontWeight || '',
    textDecoration: _vm.content.textStyle.underline === 1 ? 'underline' : '',
    fontStyle: _vm.content.textStyle.fontItalic === 1 ? 'italic' : '',
    textAlign: _vm.content.textStyle.textAlign || '',
    color: _vm.content.textStyle.color || '',
    backgroundColor: _vm.content.textStyle.backgroundColor || '',
  }),attrs:{"id":_vm.content.key,"href":_vm.content.link,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();return (function (e){
    _vm.findChapterFrom(e)
    e.stopPropagation();
  })($event)}}},[_c('span',{attrs:{"id":((_vm.content.key) + "-1")}},[_vm._v(_vm._s(_vm.content.text))]),_c('img',{staticClass:"link-icon",attrs:{"id":((_vm.content.key) + "-2"),"src":_vm.content.linkIcon || require('@/assets/images/bookContent/bubble-icon-link.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }